import { combineReducers } from "redux";
import auth from "./auth";
import entities from "./entities";
import system from "./system";
import entity from "../../modules/entity/reducers";

const rootReducer = combineReducers({
	auth,
	entities,
	system,
	entity
});

export default (state, action) => (
	action.type === "LOGOUT/REQUEST" ? rootReducer({system: state.system}, action) : rootReducer(state, action)
)
